<div class="warning-container">
  <div class="warning-icon">
    <mat-icon>warning</mat-icon>
  </div>
  <h2 mat-dialog-title class="title">AVISO</h2>
</div>
<mat-dialog-content>
  <p class="message">Su clave está próxima a expirar</p>
  <p class="days-message" *ngIf="daysRemaining !== undefined">
    Le quedan <strong>{{ daysRemaining }}</strong> {{ daysRemaining === 1 ? 'día' : 'días' }} para cambiar su contraseña.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>
